"use client";

import {useCallback, useState} from "react";

import {type SwipeableHandlers, useSwipeable} from "react-swipeable";

import {type DateRangePickerInstance} from "@/shared/models/form/datepickers";

type AnimationDirection = "left" | "right" | null;

interface UseSwipeAnimationReturn {
    swipeHandlers: SwipeableHandlers;
    animationDirection: AnimationDirection;
}

export function useSwipeAnimation(model: DateRangePickerInstance): UseSwipeAnimationReturn {
    const [animationDirection, setAnimationDirection] = useState<AnimationDirection>(null);

    const swipeHandlers = useSwipeable({
        onSwipedLeft: useCallback(() => {
            setAnimationDirection("left");
            model.nextMonth();
            setTimeout(() => setAnimationDirection(null), 400);
        }, [model]),
        onSwipedRight: useCallback(() => {
            setAnimationDirection("right");
            model.previousMonth();
            setTimeout(() => setAnimationDirection(null), 400);
        }, [model]),
        preventScrollOnSwipe: false,
        trackTouch: true,
        trackMouse: false,
        delta: 60,
        swipeDuration: 500,
        onSwiping: (eventData) => {
            const isHorizontal = Math.abs(eventData.deltaX) > Math.abs(eventData.deltaY);
            if (!isHorizontal && eventData.first) {
                return false;
            }
        },
    });

    return {swipeHandlers, animationDirection};
}
